"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const nodeListToArray_1 = require("../general/nodeListToArray");
const attrToSelector_1 = require("./attrToSelector");
exports.findEls = (el, attr) => {
    return nodeListToArray_1.nodeListToArray(el.querySelectorAll(attrToSelector_1.attrToSelector(attr)));
};
//# sourceMappingURL=findEls.js.map